/**
 * Multi-Site Region Banner
 * 基于 IP 地区与当前站点不匹配时显示 Banner，不再自动跳转
 */
(function () {
  'use strict';

  function parseRegionMapping(raw) {
    const mapping = {};
    if (!raw) return mapping;
    String(raw)
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
      .forEach((pair) => {
        const parts = pair.split(':');
        if (parts.length < 2) return;
        const country = (parts[0] || '').trim().toUpperCase();
        const siteKey = (parts[1] || '').trim();
        if (!country || !siteKey) return;
        mapping[country] = siteKey;
      });
    return mapping;
  }

  function ensureSiteConfig() {
    if (window.siteConfig) return window.siteConfig;
    const el = document.getElementById('momcozy-site-config-json');
    if (!el) return null;
    try {
      const raw = JSON.parse(el.textContent || '{}');
      const config = {
        currentSiteKey: raw.currentSiteKey || 'main',
        siteMapping: raw.siteMapping || {},
        regionToSite: parseRegionMapping(raw.regionMappingRaw || ''),
      };
      window.siteConfig = config;
      return config;
    } catch (e) {
      console.error('[Multi-Site] Failed to parse site config JSON:', e);
      return null;
    }
  }

  const siteConfig = ensureSiteConfig() || {};

  const COOKIE = {
    preferredRegion: 'user_preferred_region',
    dismissBanner: 'dismiss_region_banner',
    preferredRegionDays: 90,
    dismissDays: 30,
  };

  const CONFIG = {
    regionApiUrl: `${window.__MC__CONFIG__.apiUrl}/api/base/region/defaultRegion`,
    currentSiteKey: siteConfig.currentSiteKey || 'main',
    siteMapping: siteConfig.siteMapping || {},
    regionToSite: siteConfig.regionToSite || {},
  };

  const bannerState = {
    userRegion: null,
    targetSiteKey: null,
    targetSiteUrl: null,
    exposeReported: false,
  };

  function trackEvent(eventName, data) {
    if (typeof window.luteTrack !== 'function') return;
    try {
      window.luteTrack(eventName, data && typeof data === 'object' ? data : {});
    } catch (e) {
      /* no-op */
    }
  }

  function bannerTrackPayload() {
    return {
      user_region: bannerState.userRegion || '',
      target_site_key: bannerState.targetSiteKey || '',
      target_site_url: bannerState.targetSiteUrl || '',
      current_site_key: CONFIG.currentSiteKey || '',
      href: typeof window.location !== 'undefined' ? window.location.href || '' : '',
    };
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return null;
  }

  function getTopLevelDomain() {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return '';
    const parts = hostname.split('.');
    if (parts.length < 2) return '';
    return `.${parts.slice(-2).join('.')}`;
  }

  /** 业务约定：写入父域（如 .momcozy.com），所有子站可读同一偏好 */
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    const domain = getTopLevelDomain();
    const domainPart = domain ? `;domain=${domain}` : '';
    document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/${domainPart};SameSite=Lax`;
  }

  function setPreferredRegion(regionCode) {
    if (!regionCode) return;
    setCookie(COOKIE.preferredRegion, String(regionCode).toUpperCase(), COOKIE.preferredRegionDays);
  }

  function getPreferredRegion() {
    return getCookie(COOKIE.preferredRegion);
  }

  function setDismissRegion(regionCode) {
    if (!regionCode) return;
    setCookie(COOKIE.dismissBanner, String(regionCode).toUpperCase(), COOKIE.dismissDays);
  }

  function getDismissRegion() {
    return getCookie(COOKIE.dismissBanner);
  }

  async function getUserRegion() {
    try {
      const response = await fetch(CONFIG.regionApiUrl, {
        headers: window.__MC__CONFIG__.headers,
      });
      if (!response.ok) throw new Error(`API request failed: ${response.status}`);
      const data = await response.json();
      return (data?.result?.iso2 || '').toUpperCase() || null;
    } catch (error) {
      console.error('[Multi-Site] Failed to fetch user region:', error);
      return null;
    }
  }

  function getTargetSiteByRegion(regionCode) {
    if (!regionCode) return null;
    const siteKey = CONFIG.regionToSite[regionCode] || 'main';
    const siteUrl = CONFIG.siteMapping[siteKey] || CONFIG.siteMapping.main;
    if (!siteUrl) return null;
    return { key: siteKey, url: siteUrl };
  }

  function buildTargetUrl(siteUrl) {
    try {
      const target = new URL(siteUrl);
      target.pathname = window.location.pathname || '/';
      target.search = window.location.search || '';
      target.hash = window.location.hash || '';
      return target.toString();
    } catch (e) {
      return siteUrl;
    }
  }

  function getBannerElements() {
    return {
      root: document.querySelector('[data-multi-site-banner]'),
      message: document.querySelector('[data-multi-site-banner-message]'),
      switchBtn: document.querySelector('[data-multi-site-banner-switch]'),
      closeBtn: document.querySelector('[data-multi-site-banner-close]'),
    };
  }

  /** 由 section Liquid 根据 request.page_type + 主题设置输出 true/false */
  function isBannerPageAllowed() {
    const root = document.querySelector('[data-multi-site-banner]');
    if (!root) return false;
    return root.getAttribute('data-multi-site-banner-page-allowed') === 'true';
  }

  function renderBannerMessage(regionCode) {
    const elements = getBannerElements();
    if (!elements.root || !elements.message) return;
    const template = elements.root.dataset.message || '';
    const content = template.replace(/\{\{\s*country\s*\}\}/gi, regionCode || '');
    elements.message.textContent = content;
  }

  function hideBanner() {
    const elements = getBannerElements();
    if (!elements.root) return;
    elements.root.hidden = true;
  }

  function showBanner(regionCode) {
    const elements = getBannerElements();
    if (!elements.root) return;
    renderBannerMessage(regionCode);
    elements.root.hidden = false;
    if (!bannerState.exposeReported) {
      bannerState.exposeReported = true;
      trackEvent('multi_site_region_banner:expose', bannerTrackPayload());
    }
  }

  function setupBannerActions() {
    const elements = getBannerElements();
    if (!elements.root) return;

    if (elements.switchBtn) {
      elements.switchBtn.addEventListener('click', function () {
        if (!bannerState.userRegion || !bannerState.targetSiteUrl) return;
        trackEvent('multi_site_region_banner:switch_click', bannerTrackPayload());
        setPreferredRegion(bannerState.userRegion);
        window.location.href = buildTargetUrl(bannerState.targetSiteUrl);
      });
    }

    if (elements.closeBtn) {
      elements.closeBtn.addEventListener('click', function () {
        trackEvent('multi_site_region_banner:close_click', bannerTrackPayload());
        if (bannerState.userRegion) {
          setDismissRegion(bannerState.userRegion);
        }
        hideBanner();
      });
    }
  }

  function setupRegionSelectionListener() {
    document.addEventListener(
      'click',
      function (event) {
        const item = event.target.closest('.language-currency-panel__item, [data-manual-country-item]');
        if (!item) return;
        const countryIso = (item.dataset.country || '').toUpperCase();
        if (!countryIso) return;
        const targetSite = getTargetSiteByRegion(countryIso);
        if (!targetSite || targetSite.key === CONFIG.currentSiteKey) return;
        setPreferredRegion(countryIso);
      },
      true
    );

    document.addEventListener('momcozy:site-switched', function (event) {
      const countryIso = (event.detail?.country || '').toUpperCase();
      if (!countryIso) return;
      setPreferredRegion(countryIso);
    });
  }

  async function checkRegionMismatch() {
    if (!isBannerPageAllowed()) return;

    const userRegion = await getUserRegion();
    if (!userRegion) return;

    const targetSite = getTargetSiteByRegion(userRegion);
    if (!targetSite) return;

    bannerState.userRegion = userRegion;
    bannerState.targetSiteKey = targetSite.key;
    bannerState.targetSiteUrl = targetSite.url;

    const dismissedRegion = (getDismissRegion() || '').toUpperCase();
    if (dismissedRegion === userRegion) return;

    const preferredRegion = (getPreferredRegion() || '').toUpperCase();

    if (preferredRegion) return;

    if (targetSite.key === CONFIG.currentSiteKey) return;

    showBanner(userRegion);
  }

  function init() {
    if (!CONFIG.siteMapping || Object.keys(CONFIG.siteMapping).length === 0) {
      console.warn('[Multi-Site] Missing site mapping, banner disabled');
      return;
    }
    setupBannerActions();
    setupRegionSelectionListener();
    if (!isBannerPageAllowed()) {
      return;
    }
    checkRegionMismatch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.MomcozyMultiSite = Object.assign(window.MomcozyMultiSite || {}, {
    setPreferredRegion,
    getPreferredRegion,
    setUserPreference: setPreferredRegion,
    getUserPreference: getPreferredRegion,
    checkAndRedirect: checkRegionMismatch,
  });
})();
